import { Badge } from "@/components/ui/badge";
import { InquiryStatus } from "@/types/types";

/**
 * Get the appropriate badge variant for inquiry status
 */
export function getInquiryStatusVariant(
  status: InquiryStatus
): "default" | "secondary" | "outline" | "destructive" | "success" | "warning" {
  switch (status) {
    case "new":
      return "warning"; // Yellow - needs attention
    case "replied":
      return "default"; // Blue - in progress
    case "closed":
      return "secondary"; // Gray - completed
    default:
      return "outline";
  }
}

/**
 * Format inquiry status for display
 */
export function formatInquiryStatus(status: InquiryStatus): string {
  switch (status) {
    case "new":
      return "New";
    case "replied":
      return "Replied";
    case "closed":
      return "Closed";
    default:
      return String(status).charAt(0).toUpperCase() + String(status).slice(1);
  }
}

/**
 * Render a status badge for property inquiry
 */
export function InquiryStatusBadge({ status }: { status: InquiryStatus }) {
  return (
    <Badge variant={getInquiryStatusVariant(status)}>
      {formatInquiryStatus(status)}
    </Badge>
  );
}
